import type { ModuleDefinition } from './types'

/**
 * Modules the catalog announces that have no `SpaceModule` value yet: icon and
 * "coming soon" card only. Promote one to its own folder when it gets a screen.
 */
const planned = (key: string, icon: ModuleDefinition['icon'], iconName: string): ModuleDefinition => ({
  key,
  icon,
  iconName,
  ready: false
})

export const PLANNED_MODULES: ModuleDefinition[] = []

/* Kept for the next announced module. */
export { planned }
